module.exports = __webpack_public_path__ + "img/digital-ocean.20dedf91.png";